import { EventEmitter } from "@angular/core";

export class DishGalleryWindowContext {
    onImageSelected = new EventEmitter();
}